module.exports = __webpack_public_path__ + "static/media/img63.f5d16d05.jpg";